import './index.css';
import { Typography } from '@mui/material';

const AnimatedLetters = ({ letterClass, strArray, idx }) => {
  return (
    <Typography variant='h1'>
      {strArray.map((char, i) => (
        <span key={char + i} className={`${letterClass} _${i + idx}`}>
          {char}
        </span>
      ))}
    </Typography>
  )
}

export default AnimatedLetters
